import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { useOrderSearchNavigation } from '@euler/app/flows/search/screens';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { FormElementCaret } from '@euler/components/form/elements-ui/Caret';
import { Img } from '@euler/components/image/AdvancedImage';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { VehicleBrandInfo } from '@euler/model/vehicle';
import { usePersistFn } from '@euler/utils/hooks';
import { memo, useCallback, useEffect, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';

export const VehicleBrandField = memo(() => {
  const { rpx } = useResponsiveContext();
  const { form } = useOrderSearchForm();

  const navigation = useOrderSearchNavigation();

  const [selectedBrand, setSelectedBrand] = useState<VehicleBrandInfo>();

  const onPress = usePersistFn(() => {
    navigation.push('_vehicleBrandSelector', {
      mode: 'brand-only',
      withCustomModel: false,
      onSelectBrand: brand => {
        setSelectedBrand(brand);
        form.vehicleBrandName.update(brand.name);
      },
    });
  });

  const onChangeText = useCallback(
    (s: string) => {
      if (!s) {
        form.vehicleBrandName.update(undefined);
      }
    },
    [form.vehicleBrandName],
  );

  useEffect(() => {
    if (!form.vehicleBrandName.value) {
      setSelectedBrand(undefined);
    }
  }, [form.vehicleBrandName.value]);

  return (
    <FormGroup label="车型品牌">
      <TouchableOpacity onPress={onPress}>
        <Input
          value={form.vehicleBrandName.value ?? ''}
          placeholder="按车型品牌搜索"
          editable={false}
          pointerEvents="none"
          clearButtonMode="always"
          inputStyle={
            selectedBrand?.logo != null
              ? {
                  paddingLeft: rpx(40),
                }
              : undefined
          }
          clearStyle={{
            transform: [{ translateX: rpx(-26) }],
          }}
          onChangeText={onChangeText}
        />
        {selectedBrand?.logo != null && (
          <View
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              paddingLeft: rpx(10),
              justifyContent: 'center',
            }}
          >
            <Img
              uri={selectedBrand.logo}
              style={{
                width: rpx(24),
                height: rpx(24),
                borderRadius: rpx(24),
                overflow: 'hidden',
              }}
            />
          </View>
        )}
        <FormElementCaret
          iconSize={rpx(21)}
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: rpx(32),
            justifyContent: 'center',
            alignItems: 'center',
            transform: [{ rotate: '180deg' }],
          }}
        />
      </TouchableOpacity>
    </FormGroup>
  );
});
